import { useEffect, useState} from "react";
import useAccountData from "hooks/useAccountData";
import LoadingScreen from "components/LoadingScreen";
import MyCompanies from "./MyCompanies";
import NoCompany from "./NoCompany";
import CustomerSupportPromo from "components/CustomerSupportPromo";
import Blog from "components/Blog";

export default function GetCompany(){
  const [companies, setCompanies] = useState(false);
  const { getCompanies, loadingCompanies} = useAccountData();
  const [displaySalePromo, setDisplaySalePromo] = useState(false);

  const DisplayCompanies = () => {
    return companies ? <MyCompanies /> : <NoCompany />
  }

  useEffect(() => {
    async function fetchData() {
      if(!loadingCompanies) {
        const response = await getCompanies();
        if(response != null && response.length > 0) {
          const display = response.some(x => x.hasStats);
          setDisplaySalePromo(display);
          setCompanies(true);
        }
      }
    }
    fetchData();
    
  }, [getCompanies, loadingCompanies]);
  return (
    <>
    {loadingCompanies ? (<LoadingScreen />) : (<><DisplayCompanies />
    {displaySalePromo ? <Blog id={"min-bedrift-promo-for-dm1881no"}/> : <CustomerSupportPromo showExtraInfo={true} />}
    </>)}
    </>
  );
};
